import { ImageUrlsByPlatform } from '../../../common';
import { ContentViewModel } from '../carousel-item/content-view.model';

export enum HeroItemActionClickType {
  PlayClick = 'play click',
  MoreInfoClick = 'more info click',
  MyListClick = 'my list click',
  StartOverClick = 'start over click',
}

export interface HeroItemViewModel {
  content: ContentViewModel;
  backgroundImageUrlsByPlatform?: ImageUrlsByPlatform[];
  ribbon: string;
}
